const normalizeRotation = (rotation: number) => ((rotation % 360) + 360) % 360;

const loadImageFromBlob = (blob: Blob): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const imageUrl = URL.createObjectURL(blob);
    const image = new Image();

    const cleanup = () => URL.revokeObjectURL(imageUrl);

    image.onload = () => {
      cleanup();
      resolve(image);
    };
    image.onerror = () => {
      cleanup();
      reject(new Error('Unable to load image for rotation'));
    };
    image.src = imageUrl;
  });

export const rotateImageBlob = async (blob: Blob, rotation: number): Promise<Blob> => {
  const normalizedRotation = normalizeRotation(rotation);
  if (normalizedRotation === 0) {
    return blob;
  }

  const image = await loadImageFromBlob(blob);
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Unable to create image editor');
  }

  const isSideways = normalizedRotation === 90 || normalizedRotation === 270;
  canvas.width = isSideways ? image.naturalHeight : image.naturalWidth;
  canvas.height = isSideways ? image.naturalWidth : image.naturalHeight;

  if (blob.type === 'image/jpeg') {
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
  }

  context.translate(canvas.width / 2, canvas.height / 2);
  context.rotate((normalizedRotation * Math.PI) / 180);
  context.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (rotatedBlob) => {
        if (!rotatedBlob) {
          reject(new Error('Unable to save rotated image'));
          return;
        }

        resolve(rotatedBlob);
      },
      blob.type || 'image/png',
      0.92
    );
  });
};
